export const PHONE_DISPLAY = "281-541-8800";
export const PHONE_HREF = "tel:+12815418800";
export const SMS_HREF = "sms:+12815418800";
export const PHONE2_DISPLAY = "281-780-0921";
export const PHONE2_HREF = "tel:+12817800921";
export const SMS2_HREF = "sms:+12817800921";
export const EMAIL = "drywall3stan@gmail.com";
export const EMAIL_HREF = `mailto:${EMAIL}`;
